'use strict';

import React, {Component} from 'react';

import {observer} from "mobx-react";

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import Broken from '@uw-it-sis/lib-react/lib/Broken';
import UnknownState from '@uw-it-sis/lib-react/lib/UnknownState';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import {MetricLabels} from './Constants';

import termStore from '@uw-it-sis/lib-react/lib/TermStore';

const analyticsStore = appStore.getAnalyticsStore();

/**
 * Global nav term button.
 */
class RegistrationTermButton extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = termStore;

        // Bind this to click handlers.
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.store.load('publishedTerms');
    }

    /**
     * Click handler for the registration button.
     */
    handleClick = (termId) => {
        const labels = analyticsStore.label(MetricLabels.quarter, termId).get();
        analyticsStore.addEvent("Global-RegLinkClick", labels,{});
    }

    render() {
        let component = null;
        let terms = this.store.get('publishedTerms');

        switch (this.store.state) {
            case States.unauthenticated:
            case States.initial:
            case States.pending:
                component = null;
                break;

            case States.done:
                if ( appStore.isAuthenticated() && appStore.isStudent() ) {
                    let registrationTerms = terms.map(function (term, i) {
                        let termDescriptor = term.shortName.replace(/\s/g, '').toLowerCase();
                        return (
                            <Button id={"registration-" + term.id}
                                    variant="outline-white"
                                    className="my-2 px-3"
                                    onClick={(e) => this.handleClick(term.id, e)}
                                    title={term.shortName}
                                    key={i}
                                    href={"/plan/#/" + termDescriptor}>
                                {TermUtils.makeTermAbbrFromTermId(term.id)}
                            </Button>
                        );
                    }, this);

                    component =
                        <div className="d-print-none d-flex align-items-center" aria-label="Planable Quarters" role="navigation">
                            <div className="me-3 d-none d-sm-block text-white">Planning</div>
                            <ButtonToolbar className="keep-horizontal">
                                {registrationTerms}
                            </ButtonToolbar>
                        </div>;
                }

                break;

            case States.error:
                component = <Broken name="RegistrationTermButton"/>;
                break;

            default:
                component = <UnknownState name="RegistrationTermButton"/>;
        }

        return component;
    }
}

export default observer(RegistrationTermButton);